export default "<p>\r\n  prices works!\r\n</p>\r\n";